<template>
  <div>
    {{ version }}
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'DataOrganismDicomCaseVersionMolecule',

    props: {
      value: Object,
      moduleUuid: String,
    },

    computed: {
      ...mapGetters('repositoryUpload', ['getInstanceForModuleAndSubject']),
      ...mapGetters('projectSubjects', ['subject']),

      version() {
        if (this.value?.isSeparator) {
          return '';
        }

        return (
          this.value?.data?.upload?.from_version ??
          this.value?.upload?.from_version ??
          this.value?.event_run?.version ??
          this.getInstanceForModuleAndSubject(this.moduleUuid, this.subject?.uuid)?.runVersion
        );
      },
    },
  };
</script>
